import {
  type CreatableImportEntity,
  type CreatableUnsavedImport,
  type ImportHeader,
  type ImportHeaderInput,
  type ImportHeaderSuccess,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { importHeadersKey } from '../keys'
import { type GetHookResponse } from '../hooks'

type ImportHeadersInput = Pick<CreatableUnsavedImport, 'entity' | 'workflowId'>

export function useImportHeaders(input: ImportHeadersInput): GetHookResponse<ImportHeader[]> {
  const isArea = input.entity === 'Area'

  return useTantalimQuery<ImportHeaderInput, ImportHeaderSuccess, ImportHeader[]>({
    url: isArea ? '' : getImportUrl(input.entity),
    queryKey: importHeadersKey(input),
    input: { importData: { entity: input.entity, workflowId: input.workflowId } },
    convertResponse: (data) => data.headers,
    options: isArea ? { enabled: false, placeholderData: [] } : undefined,
  })
}

function getImportUrl(entity: CreatableImportEntity): string {
  switch (entity) {
    case 'Account':
      return '/account/import/meta'
    case 'CalendarEvent':
      return '/calendar/event/import/meta'
    case 'Task':
      return '/task/import/meta'
    case 'User':
      return '/user/import/meta'
    default:
      throw new Error(`Unknown import entity: ${entity}`)
  }
}
